import React, { Component } from 'react';

import '../css/App.css';

class Number extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scrolled: false,
      n: 0,
      end: 0,
      number: '0'
    };

    this.played = false;
    this.add = 1;
    this.interval = null;
    this.start = this.start.bind(this);
  }

  componentDidMount() {
    var self = this;
  //  console.log(this.props.number);
    this.setState({
      end: this.props.number
    }, ()=>{
      if(window.innerWidth < 800) {
        //self.start();
      //  console.log('set number' + this.props.number);
        self.setState({number: this.props.number});

      }
    });
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    return (
      <span>{this.state.number}</span>
    );
  }

  start() {
    if(!this.played) {
      //var self = this;
      this.played = true;
      this.interval = setInterval(()=>{
        let n = this.state.n;
        n += this.add;

        this.add *= 1.2;

        let nString = Math.floor(n);


        if(n >= this.state.end) {
          this.setState({n: n, number: parseInt(this.state.end).toLocaleString()});
          clearInterval(this.interval);
        } else {
          this.setState({n: n, number: nString.toLocaleString()});
        }
      }, 30);
    }

  }
}

export default Number;



// WEBPACK FOOTER //
// ./src/js/Number.js